import { RefreshCw } from 'lucide-react';
import type { CallbackLogSummary } from '../../lib/api/operatorConsole';
import { ActionBadge } from './ActionBadge';

interface Props {
  log: CallbackLogSummary;
  onClick: (id: number) => void;
}

export function CallbackLogRow({ log, onClick }: Props) {
  const statusColor = log.success ? 'var(--co-success)' : 'var(--co-error)';

  return (
    <tr
      onClick={() => onClick(log.id)}
      className="cursor-pointer border-b border-ui-border hover:bg-ui-bg"
    >
      <td className="px-4 py-3 text-sm text-ui-text-secondary">
        {new Date(log.created_at).toLocaleString()}
      </td>
      <td className="px-4 py-3 text-sm">
        <ActionBadge action={log.action} />
      </td>
      <td className="px-4 py-3 text-sm font-mono text-ui-text">{log.request_method}</td>
      <td className="px-4 py-3 text-sm font-mono">
        <span style={{ color: statusColor }}>{log.response_status ?? '—'}</span>
      </td>
      <td className="px-4 py-3 text-sm text-ui-text-secondary">
        {log.duration_ms != null ? `${log.duration_ms} ms` : '—'}
      </td>
      <td className="px-4 py-3 text-sm font-mono text-ui-text-secondary">
        {log.external_transaction_id || '—'}
      </td>
      <td className="px-4 py-3 text-sm">
        {log.resent_from_callback_log_id != null && (
          <span
            className="inline-flex items-center gap-1 text-xs text-ui-text-secondary"
            title={`Resent from log #${log.resent_from_callback_log_id}`}
          >
            <RefreshCw size={12} aria-hidden="true" />
            resent
          </span>
        )}
      </td>
    </tr>
  );
}
